import React, { useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import DynamicFilterInput from "../../../../Kryzen Alpha App/Components/layouts/filter.inpit";
import getFilteredURL from "../../../../Kryzen Alpha App/Components/Functions/filters.getUrl";
import Pagination from "../../../Components/layouts/pagination";
import { FcCalendar } from "react-icons/fc";
import { BsBoxArrowInDownRight } from "react-icons/bs";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import StepRoutes from "../../../Routes/steps_routes";
import DynamicFilterSelect from "../../../Components/layouts/filter.select";
import LoadingPage from "../../../Components/layouts/loading";
import Schedule_table from "./schedule_table";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setCurrentPage,
  setReduxFilters,
} from "../../../redux/Media & Marketing/postingScheduleRedux";
const Posting_schedules = () => {
  const [data, setData] = useState([]);

  const store = useSelector((store) => store.postingScheduleReducer);
  const storeNew = useSelector((store) => store.login.user);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filters, setFilters] = useState(store.filters);
  const [page, setCurrPage] = useState(store.currentPage);
  const [showPage, setShowPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      getFilteredURL(
        "/postPlanning/get-schedules/",
        store.currentPage,
        store.filters
      )
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res.data?.data);
          setTotalPages(Math.ceil(res.data?.totalCount / 50));
        } else {
          Toast("error", "Error while getting Data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, store.currentPage]);
  useEffect(() => {
    setCurrPage(store.currentPage);
    setShowPage(Math.floor((store.currentPage - 1) / 5) * 5 + 1);
  }, [store.currentPage]);
  const setPage = (p) => {
    dispatch(setCurrentPage(p));
  };
  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcCalendar className="fs-2 me-1" /> Complete social media
                  plan
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
              <div className="col-md-4 d-none d-sm-block">
                <div className="btn-list justify-content-end d-flex">
                  <div className="btn-list justify-content-end d-flex">
                    {(storeNew.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      storeNew.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                      <a href="/create-schedule">
                        <button className="btn btn-success">
                          <FcCalendar className="me-2 fs-2" />
                          Create Schedule
                        </button>
                      </a>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 col-sm-12 py-2">
              <div className="card p-2 ">
                <div
                  id="faq-1"
                  className="accordion"
                  role="tablist"
                  aria-multiselectable="true"
                >
                  <div>
                    <div className="accordion-header m-0" role="tab">
                      <button
                        className="accordion-button fs-3 d-md-none p-0 "
                        data-bs-toggle="collapse"
                        data-bs-target="#faq-1-1"
                      >
                        <h3 className="m-1">Filter result</h3>
                      </button>
                    </div>

                    <div
                      id="faq-1-1"
                      className="accordion-collapse collapse d-md-none"
                      role="tabpanel"
                      data-bs-parent="#faq-1"
                    >
                      <div className={`accordion-body pt-0`}>
                        <div className="row">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div>

                          {/* <div className="col-12">
                            <DynamicFilterInput
                              label="Schedule Date:"
                              value={filters.scheduleDate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    scheduleDate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  scheduleDate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div> */}

                          {/* <div className="col-12">
                            <DynamicFilterSelect
                              label="Week Day:"
                              value={filters.day || ""}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    day: e.target.value,
                                  })
                                );

                                setFilters({
                                  ...filters,
                                  day: e.target.value,
                                });
                              }}
                            >
                              <option value="">All Days</option>

                              {[
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                                "Sunday",
                              ].map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div> */}

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Schedule Group Id"
                              value={filters.scheduleGroupId}
                              // onChange={(e) =>
                              //   setFilters({
                              //     ...filters,
                              //     scheduleGroupId: e.target.value,
                              //   })
                              // }
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    scheduleGroupId: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  scheduleGroupId: e.target.value,
                                });
                              }}
                              type="text"
                              placeholder="Schedule Group Id"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Posting Format:"
                              value={filters.format}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    format: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  format: e.target.value,
                                });
                              }}
                            >
                              <option value="">All Format</option>

                              {[
                                "Image(Images) 4:5",
                                "Reels / Shorts 9:16",
                                "Video 16:9",
                                "Story 9:16",
                                "Paragraphs",
                              ]?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select Page:"
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    pageName: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  pageName: e.target.value,
                                });
                              }}
                              value={filters.pageName}
                            >
                              <option value="">All Pages</option>
                              {[
                                "Kryzen Biotech",
                                "Hydroponic Masterclass",
                                "Open Talk With Sudhir Devkar",
                                "Eat Pure Greens",
                              ]?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <div className="row mt-2">
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    dispatch(setCurrentPage(1));
                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-success w-100"
                                >
                                  Apply Filter
                                </button>
                              </div>
                              <div className="col-6">
                                <button
                                  onClick={() => {
                                    dispatch(
                                      setReduxFilters({
                                        format: "",
                                        startdate: "",
                                        enddate: "",
                                        scheduleDate: "",
                                        pageName: "",
                                        scheduleGroupId: "",
                                        oldSchedule: filters.oldSchedule,
                                        day: "",
                                      })
                                    );
                                    setFilters({
                                      format: "",
                                      startdate: "",
                                      enddate: "",
                                      scheduleDate: "",
                                      pageName: "",
                                      scheduleGroupId: "",
                                      oldSchedule: filters.oldSchedule,
                                      day: "",
                                    });

                                    setRefresh(!refresh);
                                  }}
                                  className="btn btn-secondary w-100"
                                >
                                  Reset Filter
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="accordion-body d-none d-md-block ">
                      <div className="row">
                        <h3>Filter result</h3>
                        <div className="col-12">
                          <div className="col-12">
                            <DynamicFilterInput
                              label="Start Date:"
                              value={filters.startdate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    startdate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  startdate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div>
                          <div className="col-12">
                            <DynamicFilterInput
                              label="End Date:"
                              value={filters.enddate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    enddate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  enddate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div>
                          {/* <div className="col-12">
                            <DynamicFilterInput
                              label="Schedule Date:"
                              value={filters.scheduleDate}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    scheduleDate: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  scheduleDate: e.target.value,
                                });
                              }}
                              type="date"
                            />
                          </div> */}

                          {/* <div className="col-12">
                            <DynamicFilterSelect
                              label="Week Day:"
                              value={filters.day || ""}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    day: e.target.value,
                                  })
                                );

                                setFilters({
                                  ...filters,
                                  day: e.target.value,
                                });
                              }}
                            >
                              <option value="">All Days</option>

                              {[
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                                "Sunday",
                              ].map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div> */}

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Posting Format:"
                              value={filters.format}
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    format: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  format: e.target.value,
                                });
                              }}
                            >
                              <option value="">All Format</option>
                              {[
                                "Image(Images) 4:5",
                                "Reels / Shorts 9:16",
                                "Video 16:9",
                                "Story 9:16",
                                "Paragraphs",
                              ]?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>

                          <div className="col-12">
                            <DynamicFilterInput
                              label="Schedule Group Id"
                              value={filters.scheduleGroupId}
                              // onChange={(e) =>
                              //   setFilters({
                              //     ...filters,
                              //     scheduleGroupId: e.target.value,
                              //   })
                              // }
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    scheduleGroupId: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  scheduleGroupId: e.target.value,
                                });
                              }}
                              type="text"
                              placeholder="Schedule Group Id"
                            />
                          </div>

                          <div className="col-12">
                            <DynamicFilterSelect
                              label="Select Page:"
                              onChange={(e) => {
                                dispatch(
                                  setReduxFilters({
                                    ...filters,
                                    pageName: e.target.value,
                                  })
                                );
                                setFilters({
                                  ...filters,
                                  pageName: e.target.value,
                                });
                              }}
                              value={filters.pageName}
                            >
                              <option value="">All Pages</option>
                              {[
                                "Kryzen Biotech",
                                "Hydroponic Masterclass",
                                "Open Talk With Sudhir Devkar",
                                "Eat Pure Greens",
                              ]?.map((item, index) => (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              ))}
                            </DynamicFilterSelect>
                          </div>
                        </div>
                        <div className="col-12">
                          <div className="row mt-2">
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  dispatch(setCurrentPage(1));
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-success w-100"
                              >
                                Apply Filter
                              </button>
                            </div>
                            <div className="col-6">
                              <button
                                onClick={() => {
                                  dispatch(
                                    setReduxFilters({
                                      format: "",
                                      startdate: "",
                                      enddate: "",
                                      scheduleDate: "",
                                      pageName: "",
                                      oldSchedule: filters.oldSchedule,
                                      scheduleGroupId: "",
                                      day: "",
                                    })
                                  );
                                  setFilters({
                                    format: "",
                                    startdate: "",
                                    enddate: "",
                                    scheduleDate: "",
                                    pageName: "",
                                    oldSchedule: filters.oldSchedule,
                                    scheduleGroupId: "",
                                    day: "",
                                  });
                                  setRefresh(!refresh);
                                }}
                                className="btn btn-secondary w-100"
                              >
                                Reset Filter
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-9 col-sm-12 py-2">
              <div className="card">
                {data && (
                  <Schedule_table
                    data={data}
                    currentPage={page}
                    itemsPerPage={50}
                  />
                )}

                <div className="btn-list justify-content-center">
                  <div className="d-lg-none d-md-none mt-3 mb-3">
                    {(storeNew.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
                      storeNew.Role === process.env.REACT_APP_ROLE_ADMIN) && (
                      <a href="/create-schedule">
                        <button className="btn btn-success">
                          <FcCalendar className="me-2 fs-2" />
                          Create Schedule
                        </button>
                      </a>
                    )}
                  </div>
                </div>

                <Pagination
                  page={page}
                  setPage={setPage}
                  totalPages={totalPages}
                  pageDatalength={data?.length}
                  showPage={showPage}
                  setShowPage={setShowPage}
                />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Posting_schedules;
